import React, { useRef, useState, useEffect } from 'react';
import { FaHome } from 'react-icons/fa';
import { MdArrowForward, MdArrowBack } from 'react-icons/md';
import useCity from '../../../../../hooks/useCity';
import useFetch from '../../../../../hooks/useFetch';
import { getPropertyByCity } from '../../../../../services/propertyService';
import { formatCurrencyUtil, getImageUrl } from '../../../../../Utils/localStorageUtils';
import useCustomNavigate from '../../../../../hooks/useCustomNavigate';
import useCurrentLocation from '../../../../../hooks/useCurrentLocation';

const OtherProperties = () => {

  const { city, locality, isLoading } = useCurrentLocation();
  const { data: properties, loading, error } = useFetch(() => getPropertyByCity(city), [city]); // 🏡 Fetch properties
  console.log("cityyy", city)
  console.log("properties", properties)


  const {goTo} = useCustomNavigate()


  const sliderRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  useEffect(() => {
    const checkScroll = () => {
      if (sliderRef.current) {
        setCanScrollLeft(sliderRef.current.scrollLeft > 0);
        setCanScrollRight(
          sliderRef.current.scrollLeft + sliderRef.current.clientWidth <
          sliderRef.current.scrollWidth
        );
      }
    };
    checkScroll();
    sliderRef.current?.addEventListener('scroll', checkScroll);
    return () => sliderRef.current?.removeEventListener('scroll', checkScroll);
  }, []);

  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };




  return (
    <div className="bg-white px-4 sm:px-6 pt-3 pb-4 sm:pb-6 rounded-lg shadow-md relative">
      <h2 className="text-lg sm:text-[24px] font-semibold text-[#303030]  mb-4 sm:mb-6">
        Other Properties in {city}

      </h2>

      {loading && <p className="text-gray-500">Loading properties...</p>}
      {error && <p className="text-red-500">Failed to load properties.</p>}
      {!loading && !error && properties?.length === 0 && (
        <p className="text-gray-500">No properties available in {city}.</p>
      )}


      <div className="relative overflow-hidden">
        <div
          ref={sliderRef}
          className="flex space-x-4 sm:space-x-6 overflow-x-auto scrollbar-hide scroll-smooth flex-nowrap"
        >
          {!loading && !error && properties?.length > 0 && properties?.map((property, index) => {
            const {
              _id,
              basicDetails,
              aboutProperty,
              pricingAndOthers,
              mediaFiles,
              locationDetails,
            } = property;
            return (
              <div
                key={index}
                onClick={()=>{
                  goTo(`/propertydetail/${_id}`)
                }}
                className="border rounded-lg shadow-sm hover:shadow-md transition-all relative group w-[220px] sm:min-w-[250px] sm:max-w-[250px] cursor-pointer flex-shrink-0"
              >
                <div className="flex flex-col items-center justify-center h-[120px] sm:h-[150px] mb-4 bg-pink-100">
                  {mediaFiles?.length > 0 ? (
                    <img
                      src={getImageUrl(mediaFiles[0].fileName)}
                      alt="Property Image"
                      className="w-full h-full object-cover rounded-t-lg"
                      onError={(e)=>{e.target.src="https://img.staticmb.com/mbphoto/property/cropped_images/2024/Oct/15/Photo_h300_w450/75472345_1_1728976830490-9052_300_450.jpg"}}
                    />
                  ) : (
                    <>
                      <FaHome className="text-gray-400 text-3xl sm:text-4xl" />
                      <p className="text-xs sm:text-sm text-gray-500 mt-2">
                        No Image Available
                      </p>
                    </>
                  )}
                </div>
                {/* Property Details */}
                <div className="text-left px-3 sm:px-4 pb-4  h-[130px] sm:h-[150px]">
                  <p className="text-xs sm:text-sm font-normal text-[#303030]">
                    {basicDetails?.additionalOption?.value || "Property"}
                  </p>
                  <p className="text-sm sm:text-lg font-semibold text-gray-900 mt-1">
                    {formatCurrencyUtil(pricingAndOthers?.OwnershipPriceDetails?.expectedPrice)}{" "}
                    <span className="font-normal">|</span>{" "}
                    {aboutProperty?.areaDetails?.buildupArea}{" "}
                    {aboutProperty?.areaDetails?.buildupAreaUnit}
                  </p>
                  <p className="text-xs sm:text-sm text-gray-600 mt-1 line-clamp-2">
                    {locationDetails?.searchLocation}
                  </p>
                  <p className="text-xs sm:text-sm text-gray-600 mt-1">
                    {aboutProperty?.availabilityStatus}
                  </p>
                </div>
                <div className="absolute bottom-[-20px] left-0 w-full flex px-4 transition-all duration-300 opacity-0 group-hover:bottom-2 group-hover:opacity-100">
                  <button className="bg-[#2b463c] text-white  text-xs sm:text-sm font-medium px-4 py-1 rounded-full hover:bg-[#b71c1c]">
                    Contact Builder
                  </button>
                </div>
              </div>
            )
          }
          )}
        </div>
      </div>

      {canScrollLeft && (
        <div className="absolute top-1/2 left-4 transform -translate-y-1/2 group">
          <button
            onClick={handlePrev}
            className="p-2 sm:p-3 bg-white border rounded-full shadow hover:shadow-lg hover:bg-gray-100 transition-all duration-300 group-hover:bg-[#d8232a]"
          >
            <MdArrowBack className="text-[18px] sm:text-[24px] text-gray-600 group-hover:text-white group-hover:-translate-x-1 transition-all duration-300" />
          </button>
        </div>
      )}

      {canScrollRight && (
        <div className="absolute top-1/2 right-2 sm:right-4 transform -translate-y-1/2 group">
          <button
            onClick={handleNext}
            className="p-2 sm:p-3 bg-white border rounded-full shadow hover:shadow-lg hover:bg-gray-100 transition-all duration-300 group-hover:bg-[#d8232a]"
          >
            <MdArrowForward className="text-[18px] sm:text-[24px] text-gray-600 group-hover:text-white group-hover:translate-x-1 transition-all duration-300" />
          </button>
        </div>
      )}
    </div>
  );
};

export default OtherProperties;
